import {COIService} from '../../services';
import {ActivatedRoute} from '@angular/router';
import {Component, OnInit} from '@angular/core';
import {environment} from '../../../../environments/environment';
import {VoluntaryLoadManagementEventService} from '../../services/e2x/voluntary-load-management-event.service';
import {finalize} from 'rxjs/operators';

@Component({
  selector: 'app-success-screen',
  templateUrl: './success-screen.component.html',
  styleUrls: ['./success-screen.component.scss']
})
export class SuccessScreenComponent implements OnInit {
  public logoImg: string;
  public isError = false;
  public isLoading = true;

  private customerId: number;
  private acknowledgmentDecision: 'accept' | 'deny';
  private eventId: number;

  constructor(
    private route: ActivatedRoute,
    private coiService: COIService,
    private voluntaryLoadManagementEventService: VoluntaryLoadManagementEventService
  ) {
  }

  ngOnInit() {

    this.route.queryParams.subscribe((queryParam) => {
      this.coiService.setTenantID(environment.tenantID.coi);
      this.customerId = queryParam.customerId;
      this.acknowledgmentDecision = queryParam.decision;
      this.eventId = queryParam.eventId;
      this.logoImg = this.coiService.getHeaderLogo();
    });

    if (this.customerId && this.acknowledgmentDecision) {
      this.voluntaryLoadManagementEventService.acknowledgeEvent(this.customerId, this.acknowledgmentDecision, this.eventId)
        .pipe(finalize(() => {
          this.isLoading = false;
        })).subscribe(r => {
          this.isLoading = false;
          this.isError = false;
        }, err => {
          this.isLoading = false;
          this.isError = true;
        }
      );
    }
  }

  public bannerLogo() {
    return '../../assets/images/' + 'e2x-logo.svg';
  }
}
